<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-row wrap>
      <v-col cols="12">
        <h1 class="text-h5 mb-6">{{ $t('VapeVault') }}</h1>
      </v-col>
    </v-row>
    <v-row wrap>
      <v-col cols="3">
        <search-filter
          ref="searchFilter"
          @change="enteredQuery" />

        <flavor-profile-filter
          ref="flavorProfileFilter"
          class="mt-5"
          @change="selectedFlavorProfile" />

        <flavor-filter
          ref="flavorFilter"
          :selected-flavors-array="searchParams.flavor"
          class="mt-5"
          @change="selectedFlavor"
        />
        <family-filter
          ref="familyFilter"
          class="mt-5"
          @change="selectedFamily"
        />
        <pg-vg-filter
          ref="pgVgFilter"
          class="mt-5"
          @change="selectedPgVgRatio"
        />
        <v-btn
          v-show="hasActiveFilters"
          class="mt-3 ml-n4"
          text
          size="sm"
          plain
          @click="resetSearchParams"
        >
          <v-icon class="mr-3">fal fa-rotate-left</v-icon>
          {{ $t('Reset Filters') }}
        </v-btn>

      </v-col>
      <v-col cols="9">
        <results
          v-if="searchParams"
          ref="resultsComponent"
          :search-params="searchParams"
          @selected-flavor="clickedFlavorChip" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import InfoCard from '@/components/InfoCard'
import Results from '@/components/vapevault/Results'
import FlavorFilter from '@/components/vapevault/filters/FlavorFilter'
import FamilyFilter from '@/components/vapevault/filters/FamilyFilter'
import PgVgFilter from '../components/vapevault/filters/PgVgFilter'
import VolumeFilter from '../components/vapevault/filters/VolumeFilter'
import FlavorProfileFilter from '../components/vapevault/filters/FlavorProfileFilter'
import SearchFilter from '../components/vapevault/filters/SearchFilter'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    InfoCard,
    FamilyFilter,
    FlavorFilter,
    PgVgFilter,
    Results,
    VolumeFilter,
    FlavorProfileFilter,
    SearchFilter
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('VapeVault'),
    defaultParams: {
      flavorCondition: 'OR',
      family: [],
      flavor: [],
      flavorProfile: [],
      volume: [],
      pgVgRatio: [],
      searchQuery: ''
    },
    searchParams: null
  }),

  computed: {
    hasActiveFilters () {
      return !_.isEqual(this.defaultParams, this.searchParams)
    }
  },

  created () {
    this.searchParams = { ...this.defaultParams }
  },

  methods: {
    enteredQuery (query) {
      this.searchParams.searchQuery = query.searchQuery
    },
    selectedFlavorProfile (profile) {
      this.searchParams.flavorProfile = profile.selectedFlavorProfiles
    },
    selectedFlavor (flavor) {
      this.searchParams.flavorCondition = flavor.flavorCondition
      this.searchParams.flavor = flavor.selectedFlavors
    },
    selectedFamily (family) {
      this.searchParams.family = family.selectedFamilies
      this.searchParams.volume = family.selectedVolumes
    },
    selectedPgVgRatio (pgVgRatio) {
      this.searchParams.pgVgRatio = pgVgRatio.selectedPgVgRatios
    },
    clickedFlavorChip (flavor) {
      this.resetSearchParams()
      this.searchParams.flavor = [flavor.name]
      this.$refs.resultsComponent.hideInfo()
    },
    resetSearchParams () {
      this.$refs.searchFilter.reset()
      this.$refs.flavorProfileFilter.reset()
      this.$refs.flavorFilter.reset()
      this.$refs.familyFilter.reset()
      this.$refs.pgVgFilter.reset()
    }
  }
}
</script>

<style scoped lang="scss">

.divider {
  border-width: 2px;
  border-color: #f7f7f7 !important;
}

.filter-box {
  background-color: #fbfbfb;
    border: 1px solid #e1dfdf;
    border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/VapeVault.vue